import { toFixedDecimal } from "./utils";
export default class P_Frame {
    constructor() {
        this["12V"] = '0';
        this["1V2DspCore"] = '0';
        this["2V5Offset"] = '0';
        this["36V"] = '0';
        this["3V2ndReference"] = '0';
        this["3V3"] = '0';
        this["3VReference"] = '0';
        this["5V"] = '0';
        this["5VLogic"] = '0';
        this["CPU1Ver"] = '0';
        this["CPU2Ver"] = '0';
        this["FrameTJunction"] = '0';
        this["FrameTemp"] = '0';
        this["RelVer"] = '0';
        this["iMonCurrent"] = '0';
    }
    //dot notation is used in this file because the key names start with a numeric digit that dot operator cannot handle
    static fromJson(json) {
        if (json) {
            let p_Frame = new P_Frame();
            if (json["12V"]) {
                p_Frame["12V"] = toFixedDecimal(json["12V"]);
            }
            if (json["1V2DspCore"]) {
                p_Frame["1V2DspCore"] = toFixedDecimal(json["1V2DspCore"]);
            }
            if (json["2V5Offset"]) {
                p_Frame["2V5Offset"] = toFixedDecimal(json["2V5Offset"]);
            }
            if (json["36V"]) {
                p_Frame["36V"] = toFixedDecimal(json["36V"]);
            }
            if (json["3V2ndReference"]) {
                p_Frame["3V2ndReference"] = toFixedDecimal(json["3V2ndReference"]);
            }
            if (json["3V3"]) {
                p_Frame["3V3"] = toFixedDecimal(json["3V3"]);
            }
            if (json["3VReference"]) {
                p_Frame["3VReference"] = toFixedDecimal(json["3VReference"]);
            }
            if (json["5V"]) {
                p_Frame["5V"] = toFixedDecimal(json["5V"]);
            }
            if (json["5VLogic"]) {
                p_Frame["5VLogic"] = toFixedDecimal(json["5VLogic"]);
            }
            if (json.CPU1Ver) {
                p_Frame.CPU1Ver = toFixedDecimal(json.CPU1Ver);
            }
            if (json.CPU2Ver) {
                p_Frame.CPU2Ver = toFixedDecimal(json.CPU2Ver);
            }
            if (json.FrameTJunction) {
                p_Frame.FrameTJunction = toFixedDecimal(json.FrameTJunction);
            }
            if (json.FrameTemp) {
                p_Frame.FrameTemp = toFixedDecimal(json.FrameTemp);
            }
            if (json.RelVer) {
                p_Frame.RelVer = toFixedDecimal(json.RelVer);
            }
            if (json.iMonCurrent) {
                p_Frame.iMonCurrent = toFixedDecimal(json.iMonCurrent);
            }
            return p_Frame;
        }
        return null;
    }
}
//# sourceMappingURL=P_Frame.js.map